/**
 * App shell: header offset, screen-header heights, mobile menu.
 */
(function () {
  var header = null;

  var screenHeaderBreakpoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  };

  function getScreenHeaderMinWidth(el) {
    var classes = Array.prototype.slice.call(el.classList);
    var minWidth = null;

    for (var i = 0; i < classes.length; i++) {
      var className = classes[i];
      if (className === 'h-screen-header') {
        minWidth = 0;
        continue;
      }

      var match = className.match(/^(sm|md|lg|xl|2xl):h-screen-header$/);
      if (!match) continue;

      var bp = screenHeaderBreakpoints[match[1]];
      minWidth = minWidth === null ? bp : Math.min(minWidth, bp);
    }

    return minWidth;
  }

  function getScreenHeaderEls() {
    return Array.prototype.slice.call(document.querySelectorAll('[class*="h-screen-header"]')).filter(function (el) {
      return getScreenHeaderMinWidth(el) !== null;
    });
  }

  function syncHeaderOffset() {
    if (!header) return;
    const heightWithOffset = header.offsetHeight + header.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--header-height', heightWithOffset + 'px');
  }

  function applyScreenHeaderHeights() {
    if (!header) return;
    syncHeaderOffset();
    var screenHeaderEls = getScreenHeaderEls();
    if (!screenHeaderEls.length) return;

    var width = window.innerWidth;
    var height = window.innerHeight - header.offsetHeight + 'px';

    screenHeaderEls.forEach(function (el) {
      var minWidth = getScreenHeaderMinWidth(el);
      if (minWidth !== null && width >= minWidth) {
        el.style.height = height;
      } else {
        el.style.height = '';
      }
    });
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.getElementById('mobile-menu');
    if (!toggle || !menu || toggle.getAttribute('data-menu-inited') === '1') return;
    toggle.setAttribute('data-menu-inited', '1');

    var iconOpen = toggle.querySelector('[data-mobile-menu-icon-open]');
    var iconClose = toggle.querySelector('[data-mobile-menu-icon-close]');
    var xlMq = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 1280px)') : null;
    var reduceMotion =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasGsap = typeof window.gsap !== 'undefined';
    var tween = null;

    function isOpen() {
      return menu.getAttribute('aria-hidden') === 'false';
    }

    function killTween() {
      if (!tween) return;
      tween.kill();
      tween = null;
    }

    function setChrome(open) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      menu.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('overflow-hidden', open);
      if (iconOpen) iconOpen.classList.toggle('hidden', open);
      if (iconClose) iconClose.classList.toggle('hidden', !open);
    }

    function hideMenu() {
      menu.hidden = true;
      menu.classList.add('hidden');
      if (hasGsap) window.gsap.set(menu, { clearProps: 'opacity,visibility' });
    }

    function showMenu() {
      menu.hidden = false;
      menu.classList.remove('hidden');
    }

    function setOpen(open) {
      if (open === isOpen() && !tween) return;

      killTween();
      setChrome(open);

      if (reduceMotion || !hasGsap) {
        if (open) showMenu();
        else hideMenu();
        return;
      }

      if (open) {
        showMenu();
        tween = window.gsap.fromTo(
          menu,
          { autoAlpha: 0 },
          {
            autoAlpha: 1,
            duration: 0.35,
            ease: 'power2.out',
            onComplete: function () {
              tween = null;
            },
          },
        );
        return;
      }

      tween = window.gsap.to(menu, {
        autoAlpha: 0,
        duration: 0.28,
        ease: 'power2.out',
        onComplete: function () {
          hideMenu();
          tween = null;
        },
      });
    }

    toggle.addEventListener('click', function () {
      setOpen(!isOpen());
    });

    function onXlChange(event) {
      if (event.matches) setOpen(false);
    }

    if (xlMq) {
      if (xlMq.addEventListener) xlMq.addEventListener('change', onXlChange);
      else if (xlMq.addListener) xlMq.addListener(onXlChange);
    }
  }

  function initCart() {
    var cart = document.getElementById('cart');
    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-cart-toggle]'));
    if (!cart || !toggles.length || cart.getAttribute('data-cart-inited') === '1') return;
    cart.setAttribute('data-cart-inited', '1');

    var closers = Array.prototype.slice.call(document.querySelectorAll('[data-cart-close]'));
    var reduceMotion =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasGsap = typeof window.gsap !== 'undefined';
    var tween = null;

    function isOpen() {
      return cart.getAttribute('aria-hidden') === 'false';
    }

    function killTween() {
      if (!tween) return;
      tween.kill();
      tween = null;
    }

    function setChrome(open) {
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
      });
      cart.setAttribute('aria-hidden', String(!open));
    }

    function hideCart() {
      cart.hidden = true;
      cart.classList.add('hidden');
      if (hasGsap) window.gsap.set(cart, { clearProps: 'opacity,visibility,transform,x,xPercent' });
    }

    function showCart() {
      cart.hidden = false;
      cart.classList.remove('hidden');
    }

    function setOpen(open) {
      if (open === isOpen() && !tween) return;

      killTween();
      setChrome(open);

      if (reduceMotion || !hasGsap) {
        if (open) showCart();
        else hideCart();
        return;
      }

      if (open) {
        showCart();
        tween = window.gsap.fromTo(
          cart,
          { xPercent: 100 },
          {
            xPercent: 0,
            duration: 0.4,
            ease: 'power2.out',
            onComplete: function () {
              tween = null;
            },
          },
        );
        return;
      }

      tween = window.gsap.to(cart, {
        xPercent: 100,
        duration: 0.32,
        ease: 'power2.in',
        onComplete: function () {
          hideCart();
          tween = null;
        },
      });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        setOpen(!isOpen());
      });
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', function (event) {
        event.stopPropagation();
        setOpen(false);
      });
    });

    cart.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    document.addEventListener('click', function () {
      if (isOpen()) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function initSizeTabs() {
    document.querySelectorAll('[data-size-tabs], [data-about-tabs], [data-use-tabs]').forEach(initPanelTabs);
  }

  function initPanelTabs(root) {
    if (!root || root.getAttribute('data-tabs-inited') === '1') return;
    root.setAttribute('data-tabs-inited', '1');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
    var reduceMotion =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasGsap = typeof window.gsap !== 'undefined';
    var slide = root.hasAttribute('data-about-tabs') || root.hasAttribute('data-use-tabs');
    var tween = null;

    function panelForTab(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function showPanel(panel) {
      panel.hidden = false;
      panel.classList.remove('hidden');
    }

    function hidePanel(panel) {
      panel.hidden = true;
      panel.classList.add('hidden');
      if (hasGsap)
        window.gsap.set(panel, { clearProps: 'opacity,visibility,transform,x,xPercent,position,left,right,top,width' });
    }

    function resetSlideStyles() {
      if (!hasGsap) return;
      panels.forEach(function (panel) {
        window.gsap.set(panel, { clearProps: 'opacity,visibility,transform,x,xPercent,position,left,right,top,width' });
      });
      if (panels[0] && panels[0].parentElement) {
        window.gsap.set(panels[0].parentElement, { clearProps: 'height' });
      }
    }

    function activateTab(nextTab) {
      var nextPanel = panelForTab(nextTab);
      if (!nextPanel) return;

      var currentTab = tabs.filter(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      })[0];
      var currentPanel = currentTab ? panelForTab(currentTab) : null;

      if (currentTab === nextTab) return;

      tabs.forEach(function (tab) {
        var selected = tab === nextTab;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      if (!currentPanel || reduceMotion || !hasGsap) {
        if (tween) {
          tween.kill();
          tween = null;
        }
        resetSlideStyles();
        panels.forEach(function (panel) {
          if (panel === nextPanel) showPanel(panel);
          else hidePanel(panel);
        });
        return;
      }

      if (tween) {
        tween.kill();
        tween = null;
        resetSlideStyles();
        panels.forEach(function (panel) {
          if (panel === currentPanel) showPanel(panel);
          else hidePanel(panel);
        });
      }

      if (slide) {
        var wrap = currentPanel.parentElement;
        var fromHeight = currentPanel.offsetHeight;

        window.gsap.set(wrap, { height: fromHeight });
        showPanel(nextPanel);
        window.gsap.set(currentPanel, { position: 'absolute', left: 0, right: 0, top: 0, width: '100%' });
        window.gsap.set(nextPanel, {
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          width: '100%',
          xPercent: -40,
          autoAlpha: 0,
        });

        var toHeight = nextPanel.offsetHeight;

        tween = window.gsap.timeline({
          defaults: { duration: 0.4, ease: 'power2.inOut' },
          onComplete: function () {
            hidePanel(currentPanel);
            window.gsap.set(nextPanel, {
              clearProps: 'opacity,visibility,transform,x,xPercent,position,left,right,top,width',
            });
            window.gsap.set(wrap, { clearProps: 'height' });
            showPanel(nextPanel);
            tween = null;
          },
        });
        tween.to(currentPanel, { xPercent: 40, autoAlpha: 0 }, 0);
        tween.to(nextPanel, { xPercent: 0, autoAlpha: 1 }, 0);
        tween.to(wrap, { height: toHeight }, 0);
        return;
      }

      tween = window.gsap.to(currentPanel, {
        autoAlpha: 0,
        duration: 0.18,
        ease: 'power2.out',
        onComplete: function () {
          hidePanel(currentPanel);
          showPanel(nextPanel);
          tween = window.gsap.fromTo(
            nextPanel,
            { autoAlpha: 0 },
            {
              autoAlpha: 1,
              duration: 0.22,
              ease: 'power2.out',
              onComplete: function () {
                tween = null;
              },
            },
          );
        },
      });
    }

    tabs.forEach(function (tab, index) {
      tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });
  }

  function initLocationDropdowns() {
    var dropdowns = Array.prototype.slice.call(document.querySelectorAll('[data-location-dropdown]'));
    if (!dropdowns.length) return;

    var reduceMotion =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasGsap = typeof window.gsap !== 'undefined';
    var selected = 'Todas las ubicaciones';

    function menuOf(dropdown) {
      return dropdown.querySelector('[data-location-menu]');
    }

    function isOpen(dropdown) {
      var menu = menuOf(dropdown);
      return menu && menu.getAttribute('aria-hidden') === 'false';
    }

    function setChrome(dropdown, open) {
      var toggle = dropdown.querySelector('[data-location-toggle]');
      var menu = menuOf(dropdown);
      var chevron = dropdown.querySelector('[data-location-chevron]');
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
      if (menu) menu.setAttribute('aria-hidden', String(!open));
      if (chevron) chevron.classList.toggle('rotate-180', open);
    }

    function showMenu(menu) {
      menu.hidden = false;
      menu.classList.remove('hidden');
    }

    function hideMenu(menu) {
      menu.hidden = true;
      menu.classList.add('hidden');
      if (hasGsap) window.gsap.set(menu, { clearProps: 'opacity,visibility' });
    }

    function setOpen(dropdown, open) {
      var menu = menuOf(dropdown);
      if (!menu) return;
      if (open === isOpen(dropdown)) return;

      setChrome(dropdown, open);

      if (reduceMotion || !hasGsap) {
        if (open) showMenu(menu);
        else hideMenu(menu);
        return;
      }

      if (menu._locationTween) {
        menu._locationTween.kill();
        menu._locationTween = null;
      }

      if (open) {
        showMenu(menu);
        menu._locationTween = window.gsap.fromTo(
          menu,
          { autoAlpha: 0, y: -6 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.22,
            ease: 'power2.out',
            onComplete: function () {
              menu._locationTween = null;
            },
          },
        );
        return;
      }

      menu._locationTween = window.gsap.to(menu, {
        autoAlpha: 0,
        y: -6,
        duration: 0.16,
        ease: 'power2.out',
        onComplete: function () {
          hideMenu(menu);
          menu._locationTween = null;
        },
      });
    }

    function closeAll(except) {
      dropdowns.forEach(function (dropdown) {
        if (dropdown !== except) setOpen(dropdown, false);
      });
    }

    function applySelection(value) {
      selected = value;
      dropdowns.forEach(function (dropdown) {
        var label = dropdown.querySelector('[data-location-label]');
        if (label) label.textContent = value;
        dropdown.querySelectorAll('[data-location-option]').forEach(function (option) {
          option.setAttribute('aria-selected', String(option.getAttribute('data-location') === value));
        });
      });
    }

    dropdowns.forEach(function (dropdown) {
      var toggle = dropdown.querySelector('[data-location-toggle]');
      var menu = menuOf(dropdown);
      if (!toggle || !menu) return;

      // handle dropdown cta button (uses [var]toggle)
      const dropdownId = toggle.getAttribute('aria-controls');
      const cta = document.querySelector(`[data-location-redirect][data-trigger-dropdown='${dropdownId}']`);

      menu.setAttribute('aria-hidden', 'true');

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = !isOpen(dropdown);
        closeAll(dropdown);
        setOpen(dropdown, open);
      });

      dropdown.querySelectorAll('[data-location-option]').forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.stopPropagation();
          applySelection(option.getAttribute('data-location'));
          // apply selection to cta
          cta.href = option.dataset.url;
          setOpen(dropdown, false);
        });
      });
    });

    document.addEventListener('click', function () {
      closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    document.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        closeAll();
      });
    });
  }

  function initLocationsSwiper() {
    var el = document.querySelector('[data-locations-swiper]');
    if (!el || typeof window.Swiper === 'undefined' || el.getAttribute('data-swiper-inited') === '1') return;
    el.setAttribute('data-swiper-inited', '1');

    var parent = el.parentElement;
    var prev = parent ? parent.querySelector('[data-locations-prev]') : document.querySelector('[data-locations-prev]');
    var next = parent ? parent.querySelector('[data-locations-next]') : document.querySelector('[data-locations-next]');

    new window.Swiper(el, {
      slidesPerView: 1.25,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      breakpoints: {
        640: {
          slidesPerView: 1.75,
          spaceBetween: 16,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1536: {
          slidesPerView: 4,
          spaceBetween: 20,
          slidesOffsetBefore: 64,
          slidesOffsetAfter: 64,
        },
      },
    });
  }

  function initProductSingleSwiper() {
    var el = document.querySelector('[data-product_media_slider]');
    if (!el || typeof window.Swiper === 'undefined' || el.getAttribute('data-swiper-inited') === '1') return;
    el.setAttribute('data-swiper-inited', '1');

    var prev = el ? el.querySelector('.nav-prev') : document.querySelector('[data-locations-prev]');
    var next = el ? el.querySelector('.nav-next') : document.querySelector('[data-locations-next]');

    new window.Swiper(el, {
      slidesPerView: 1,
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      navigation: {
        prevEl: '.nav-prev',
        nextEl: '.nav-next',
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    });
  }

  function initTabsSwiper() {
    var el = document.querySelector('[data-tabs-swiper]');
    if (!el || typeof window.Swiper === 'undefined' || el.getAttribute('data-swiper-inited') === '1') return;
    el.setAttribute('data-swiper-inited', '1');

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 32,
      freeMode: true,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        640: {
          spaceBetween: 48,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1024: {
          spaceBetween: 48,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1536: {
          spaceBetween: 48,
          slidesOffsetBefore: 64,
          slidesOffsetAfter: 64,
        },
      },
    });
  }

  function initProductFilters() {
    var filters = document.getElementById('filters');
    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-filters-toggle]'));
    if (!filters || !toggles.length || filters.getAttribute('data-filters-inited') === '1') return;
    filters.setAttribute('data-filters-inited', '1');

    var closers = Array.prototype.slice.call(document.querySelectorAll('[data-filters-close]'));
    var reduceMotion =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasGsap = typeof window.gsap !== 'undefined';
    var tween = null;

    function isOpen() {
      return filters.getAttribute('aria-hidden') === 'false';
    }

    function killTween() {
      if (!tween) return;
      tween.kill();
      tween = null;
    }

    function setChrome(open) {
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
      });
      filters.setAttribute('aria-hidden', String(!open));
    }

    function hideFilters() {
      filters.hidden = true;
      filters.classList.add('hidden');
      if (hasGsap) window.gsap.set(filters, { clearProps: 'opacity,visibility,transform,x,xPercent' });
    }

    function showFilters() {
      filters.hidden = false;
      filters.classList.remove('hidden');
    }

    function setOpen(open) {
      if (open === isOpen() && !tween) return;

      killTween();
      setChrome(open);

      if (reduceMotion || !hasGsap) {
        if (open) showFilters();
        else hideFilters();
        return;
      }

      if (open) {
        showFilters();
        tween = window.gsap.fromTo(
          filters,
          { xPercent: -100 },
          {
            xPercent: 0,
            duration: 0.4,
            ease: 'power2.out',
            onComplete: function () {
              tween = null;
            },
          },
        );
        return;
      }

      tween = window.gsap.to(filters, {
        xPercent: -100,
        duration: 0.32,
        ease: 'power2.in',
        onComplete: function () {
          hideFilters();
          tween = null;
        },
      });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        setOpen(!isOpen());
      });
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', function (event) {
        event.stopPropagation();
        setOpen(false);
      });
    });

    filters.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    document.addEventListener('click', function () {
      if (isOpen()) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function initPriceRangeSlider() {
    var parent = document.querySelector('[data-price-range-slider]');
    if (!parent || parent.getAttribute('data-price-range-inited') === '1') return;
    parent.setAttribute('data-price-range-inited', '1');

    let minSlider = parent.querySelector('#min');
    let maxSlider = parent.querySelector('#max');

    if (minSlider && maxSlider) {
      const minDollars = parseInt(minSlider.dataset.range_min);
      const maxDollars = parseInt(maxSlider.dataset.range_max);
      const fromInput = parent.querySelector('#from');
      const toInput = parent.querySelector('#to');

      function numberWithSpaces(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }

      function updateDollars(rangeLimit) {
        if (rangeLimit === 'min') {
          let fromValue = ((maxDollars - minDollars) * minSlider.value) / 100 + minDollars;
          if (parseInt(fromInput.value) === fromValue) return;
          fromInput.value = Math.floor(fromValue);
          fromInput.dispatchEvent(new Event('input'));
        }
        if (rangeLimit === 'max') {
          let toValue = ((maxDollars - minDollars) * maxSlider.value) / 100 + minDollars;
          if (parseInt(toInput.value) === toValue) return;
          toInput.value = Math.ceil(toValue);
          toInput.dispatchEvent(new Event('input'));
        }
      }

      maxSlider.addEventListener('input', () => {
        let minValue = parseInt(minSlider.value);
        let maxValue = parseInt(maxSlider.value);

        if (maxValue < minValue + 10) {
          minSlider.value = maxValue - 10;
          updateDollars('min');

          if (minValue === parseInt(minSlider.min)) {
            maxSlider.value = 10;
          }
        }

        updateDollars('max');
      });

      minSlider.addEventListener('input', () => {
        let minValue = parseInt(minSlider.value);
        let maxValue = parseInt(maxSlider.value);

        if (minValue > maxValue - 10) {
          maxSlider.value = minValue + 10;
          updateDollars('max');

          if (maxValue === parseInt(maxSlider.max)) {
            minSlider.value = parseInt(maxSlider.max) - 10;
          }
        }

        updateDollars('min');
      });
    }
  }

  function initCustomVideos() {
    if (window.initCustomVideo === undefined) return;
    const videos = document.querySelectorAll("video.rdh-video");
    if (!videos.length) return;

    videos.forEach(window.initCustomVideo);
  }

  // Store locator Map
  const mapboxMap = document.querySelector('#mapbox-map');
  if (mapboxMap) {
    const locatorData = getLocatorData(mapboxMap);
    const markerImages = [];
    const { api_key, center_coords, zoom_level } = mapboxMap.dataset;
    const [centerLat, centerLng] = center_coords.split('|');
    // add marker thumbnails as images to the map to be rendered as marker symbols
    locatorData.markers.forEach((marker) => {
      locatorData.imageSources[`marker-${marker.properties.id}`] = marker.properties.thumbnail;
      markerImages.push(`marker-${marker.properties.id}`);
    });
    const mapeo = new Mapeo({
      mapboxToken: api_key,
      containerId: 'mapbox-map',
      dataSet: locatorData.markers,
      imageSources: locatorData.imageSources,
      markerVariants: [
        {
          iconImageId: 'marker-default',
          textColor: '#ffffff',
        },
      ],
      markerImages: markerImages,
      initialState: {
        centerCoords: [centerLng, centerLat],
        zoomLevel: parseInt(zoom_level),
        styleUrl: 'mapbox://styles/mapbox/streets-v12',
      },
    });
    // use the instance once it is ready
    mapeo.load((thisMapeo) => {
      console.log(thisMapeo);
      // resize event handler to resize map when viewport width changes
      let debounceTimeout;
      window.addEventListener('resize', function (event) {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(function () {
          thisMapeo.map.resize();
        }, 500);
      });
    });
  }

  function getLocatorData(mapContainer) {
    const markerList = mapContainer.querySelector('[data-markers]');
    const imageSourceList = mapContainer.querySelector('[data-image-sources]');
    if (!markerList) {
      return;
    }

    const markers = markerList.querySelectorAll('[data-marker]');
    if (!markers || !markers.length) {
      return;
    }

    const locatorData = {
      markers: [],
      imageSources: {},
    };

    // add default image sources first
    if (imageSourceList) {
      const imageSources = imageSourceList.querySelectorAll('[data-image-source]');
      if (imageSources && imageSources.length) {
        imageSources.forEach((image) => {
          const { imageSource, id } = image.dataset;
          if (!id || !imageSource) return;
          locatorData.imageSources[id] = imageSource;
        });
      }
    }
    // compose markers data
    markers.forEach((marker) => {
      const { coords, index, title, address, directions_link, phone_label, phone_link, whatsapp_label, whatsapp_link, thumbnail } = marker.dataset;
      if (!coords) return;
      const [lat, lng] = coords.split('|');
      const point = {
        coordinates: [lng, lat],
        properties: {
          id: marker.dataset.marker,
          title: title,
          address: address,
          index: index,
          directions_link: directions_link,
          phone_label: phone_label,
          phone_link: phone_link,
          whatsapp_label: whatsapp_label,
          whatsapp_link: whatsapp_link,
          thumbnail: thumbnail ?? false,
        },
      };
      locatorData.markers.push(point);
    });

    // remove elements from markup
    mapContainer.removeChild(imageSourceList);
    mapContainer.removeChild(markerList);

    return locatorData;
  }

  function onFirstLoad() {
    header = document.querySelector('header');
    syncHeaderOffset();
    initMobileMenu();
    initCart();
    initSizeTabs();
    initLocationDropdowns();
    initLocationsSwiper();
    applyScreenHeaderHeights();

    initProductFilters();
    initPriceRangeSlider();
    initProductSingleSwiper();
    initTabsSwiper();
    initCustomVideos();

    window.addEventListener('resize', applyScreenHeaderHeights);

    announcementBar = document.querySelector('aside.announcement-bar');
    if (!announcementBar) return;
    window.addEventListener('scroll', setAnnouncementBarOffset);
  }

  var announcementBar = null;
  var barIsVisible = false;
  function setAnnouncementBarOffset(event) {
    if (window.scrollY < announcementBar.offsetHeight || barIsVisible) {
      if (!barIsVisible) {
        barIsVisible = true;
      }
      if (window.scrollY >= announcementBar.offsetHeight) {
        barIsVisible = false;
      }
      syncHeaderOffset();
    }
  }

  document.addEventListener('DOMContentLoaded', onFirstLoad);
})();
